import { Component, inject, OnInit, ViewChild, viewChild, AfterViewInit, QueryList, ViewChildren } from '@angular/core';
import { AdditionalInfoComponent } from '@optima-stride-ai/optima-app-framework';
import { PlanFormComponent } from '../plan-form/plan-form.component';
import { FormLayoutComponent, IFormLayout, IFormLayoutContent, IFormLayoutFooter, IFormLayoutHeader, IPolymorphicControlMeta, PolymorphicControlService, PolyMorphicControlTypes, PolymorphicControlComponent, ToastService, ProgressIndicatorComponent, ProcessProgressType, ProcessProgressView, ShimmerVariant, iProcessProgress, IOptionWithoutIcon } from '@optima-stride-ai/optima-components';
import { DateRange } from '../../../models/interfaces/date-range-model';
import { IBizEntity, IBizEntityType, IAdditionalInfo, FieldTypes, Unit, LoggerService, IRelationshipConfiguration, BizEntityTypeCategory, BizEntityFunctionTypes, IBizEntityRelationships, RelationshipLinkType, IBizEntityRelationTarget, RelationshipTargetType, Units } from '@optima-stride-ai/core';
import { IDeliverable } from '../deliverable.model';
import { ValueRange } from '../value-range-model';
import { CardModule, FormModule, DropdownModule, ButtonModule, CardComponent, CardBodyComponent } from '@coreui/angular';
import { IconModule } from '@coreui/icons-angular';
import { KPIAndMeasureCategories } from '../../transaction(Measure)/measure.model';
import { AppStateService } from '../../state/app-state';
import { notifyStrategyEntityCreated } from '../../strategy/strategy-explorer/strategy-explorer-creation';
import { initFormStateFunc } from '../../utils/form/function-init-form-state';
import { BizEntityParentHierarchyService } from '../../utils/form/resolve-biz-entity-from-parent-hierarchy';
import { DeliverableStateStoreService, temporaryDeliverableSyncBeforeSendingToAPI } from '../../deliverables/deliverable-state-store/deliverable-state-store.service';
import { UtilService } from '../../utils/util.service';
import { DurationConstraintsService } from '../../utils/form/duration-constraints.service';
import { iPlan } from '../progress-plan.model';
import { PlanStateStoreService } from '../plan-state-store/plan-state-store.service';
import { benBizEntitySyncBeforeSendingToAPI, BizEntityTypeStateStoreService, FormBaseEntityComponent } from '@optima-stride-ai/optima-app-framework';
import { KpiStateStoreService } from '../../kpi/KPI-state-stores/kpi-state-store.service';
import { FormRelationshipFieldsComponent } from '@optima-stride-ai/optima-app-framework';
import { Explorers, getExplorerPropertiesBasedOnBizEntityType, launchExplorerDialog } from '../../modal/modal';
import { OptimaDefaultModalService } from '../../modal/modal.service';
import { AppRootStateStoreService, BizEntityStateStoreService } from '@optima-stride-ai/optima-app-framework';
import { AutoCreateEntitiesService } from '../../kpi/auto-create-entites';
import { MeasuresStateStoreService } from '../../transaction(Measure)/measure-state-store/measures-state-store.service';
import { IKPI } from '../../kpi/kpi.model';
import { IBenBizEntity } from '../../../models/interfaces/biz-entity.model';
import { RelationshipStateStoreService, AppFrameworkContextService, IXappCap } from '@optima-stride-ai/optima-app-framework';
import { TenantStateStoreService, UserContextService } from '@optima-stride-ai/optima-platform';
import { ObjectiveStateStoreService } from '../../objective/objective-state-store/objective-state-store.service';
@Component({
  selector: 'app-form-deliverable',
  imports: [FormBaseEntityComponent, AdditionalInfoComponent, PlanFormComponent, FormLayoutComponent, PolymorphicControlComponent, FormRelationshipFieldsComponent, CardModule, FormModule, DropdownModule, ButtonModule, IconModule, CardComponent, CardBodyComponent, ProgressIndicatorComponent],
  templateUrl: './form-deliverable.component.html',
  styleUrl: './form-deliverable.component.sass',
})
export class FormDeliverableComponent implements OnInit {
  @ViewChild('baseEntityForm') baseEntityFormComponent!: FormBaseEntityComponent;
  @ViewChild('additionalInfoForm') additionalInfoFormComponent!: AdditionalInfoComponent;
  @ViewChild('planForm') planFormComponent!: PlanFormComponent;
  @ViewChildren('relationshipFields') relationshipFieldsComponents!: QueryList<FormRelationshipFieldsComponent>;
  formLayout: IFormLayout = {
    header: { title: '' },
    content: { fieldItems: [] },
    footer: { actions: [] }
  };
  formFooterLayout: IFormLayout = {
    header: { title: '' },
    content: { fieldItems: [] },
    footer: { actions: [] }
  };
  kpiTriggerControls: IPolymorphicControlMeta[] = [];
  selectedIcon: string = '';
  deliverableBizEntity!: IDeliverable;
  plan!: iPlan;
  relationshipConfigurations: IRelationshipConfiguration[] = [];
  benBizEntites: IBizEntity[] = [];
  kpi: IKPI[] = [];
  relationshipAdditionalInfo: { config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[] }[] = [];
  relationshipAdditionalInfoForEdit: { config: IRelationshipConfiguration, bizEntity: IBizEntity }[] = [];
  bizEntities: IBizEntity[] = [];
  extractedTargetBizEntities: IBizEntity[] = [];
  private readonly polymorphicControlService = inject(PolymorphicControlService);
  private readonly appStateService = inject(AppStateService);
  private readonly deliverableStateStoreService = inject(DeliverableStateStoreService);
  private readonly kpiStateStoreService = inject(KpiStateStoreService);
  private readonly utilService = inject(UtilService);
  private readonly durationConstraintsService = inject(DurationConstraintsService);
  private readonly bizEntityParentHierarchyService = inject(BizEntityParentHierarchyService);
  private readonly planStateStoreService = inject(PlanStateStoreService);
  private readonly bizEntityTypesStateStoresService = inject(BizEntityTypeStateStoreService);
  private readonly loggerService = inject(LoggerService);
  private readonly toastService = inject(ToastService);
  private readonly optimaDefaultModalService = inject(OptimaDefaultModalService);
  private readonly bizEntityStateStoreService = inject(BizEntityStateStoreService);
  private readonly appRootStateStoreService = inject(AppRootStateStoreService);
  private readonly autoCreateEntitiesService = inject(AutoCreateEntitiesService);
  private readonly measureStateStoreService = inject(MeasuresStateStoreService);
  private readonly relationshipStateStoreService = inject(RelationshipStateStoreService);
  private readonly benBizEntityStateStoreService = inject(BizEntityStateStoreService);
  private readonly appFrameworkContextService = inject(AppFrameworkContextService);
  private readonly tenantStateStoreService = inject(TenantStateStoreService);
  private readonly userContextService = inject(UserContextService);
  private readonly objectiveStateStoreService = inject(ObjectiveStateStoreService);
  isEditing: boolean = false;
  protected isFormLoading = true;
  private baseFormReady = false;
  private flowDataReady = false;
  protected readonly formLoadingProgress: iProcessProgress = { id: 'form-deliverable-loading', type: ProcessProgressType.Indeterminate };
  protected readonly ProcessProgressView = ProcessProgressView;
  protected readonly ShimmerVariant = ShimmerVariant;
  private isAPICallInProgress: boolean = false;
  private currentAppId: string | undefined;

  // Duration constraints from parent objective (for edit mode)
  //  ⚠️⚠️⚠️ BUSINESS RULES NOTICE ⚠️⚠️⚠️These are business rules.Should be loaded by* code at runtime and handled as data, not as logic.* ⚠️⚠️⚠️ BUSINESS RULES NOTICE ⚠️⚠️⚠️
  private parentDurationConstraints: { from: string; to: string; value: string } | null = null;

  isAutoCreatedKPI: boolean = false;
  KPICategory = KPIAndMeasureCategories;
  isAutoKPI: Record<KPIAndMeasureCategories, boolean> = {
    [KPIAndMeasureCategories.Progress]: false,
    [KPIAndMeasureCategories.Performance]: false,
    [KPIAndMeasureCategories.Quality]: false,
    [KPIAndMeasureCategories.Innovation]: false,
    [KPIAndMeasureCategories.Composite]: false,
    [KPIAndMeasureCategories.Misc]: false,
    [KPIAndMeasureCategories.Historical_Progress]: false,
    [KPIAndMeasureCategories.Placeholder_2]: false,
    [KPIAndMeasureCategories.Placeholder_3]: false,
  };
  selectProgressionKPIObj: IKPI | undefined = undefined;
  selectPerformanceKPIObj: IKPI | undefined = undefined;
  selectQualityKPIObj: IKPI | undefined = undefined;
  selectInnovationKPIObj: IKPI | undefined = undefined;
  // ProgressKPIunit: Unit | undefined = undefined;
  objectiveSummary: { name: string; from: string; to: string } | null = null;
  /** Allow Objective category entities as parent. */
  readonly enableParentForCategory: BizEntityTypeCategory[] = [BizEntityTypeCategory.BenzaitenObjective];

  get objectiveSummaryText(): string {
    if (!this.objectiveSummary) {
      return '';
    }
    return `Objective : ${this.objectiveSummary.name} (${this.objectiveSummary.from} - ${this.objectiveSummary.to})`;
  }

  get formHeaderTitle(): string {
    return this.deliverableBizEntity?.type?.name || 'Deliverable';
  }

  get formHeaderSubtitle(): string {
    const typeName = this.deliverableBizEntity?.type?.name || 'Deliverable';
    const entityName = this.deliverableBizEntity?.name || typeName;
    return this.isEditing
      ? `Edit ${entityName} to track strategy`
      : `Create ${typeName} to track strategy`;
  }

  constructor() {
    const state = initFormStateFunc(this.appStateService);
    this.deliverableBizEntity = state.bizEntity as IDeliverable;
    this.isEditing = state.isEditing;
  }
  ngOnInit(): void {
    if (!this.currentAppId) {
      this.currentAppId = this.appFrameworkContextService.currentAppId;
    }

    // In create mode, set parent ID from context entity
    const contextEntity = this.appStateService.selectedBizEntityForEdit;
    if (!this.isEditing && contextEntity?.id) {
      this.deliverableBizEntity.parentId = contextEntity.id.toString();
    }

    // Load data FIRST, then build form with loaded data
    this.initializeForm().then(() => {
      // Build form with loaded data (no patching needed!)
      this.buildFormLayout();
      this.formFooterLayout = this.buildFormFooterLayout();

      // Build KPI controls with loaded KPI data
      this.buildKpiTriggerControls();

      // Check relationships (already loaded in edit mode)
      this.doesBizEntityHaveRelationship();

      // Set auto-KPI state based on mode
      const autoCreateKPI = !this.isEditing;
      this.setAutoKPIState(undefined, undefined, autoCreateKPI);

      // Generate plan if dates are loaded (edit mode with existing data)
      // Guard prevents plan form validation error "Please select start date" in create mode
      // if (this.dateRangePolyControlMeta.dateRangeValueFromString && 
      //     this.dateRangePolyControlMeta.dateRangeValueToString) {
      //   this.autoGeneratePlan();
      // }
      //  console.log("calling generate plan on on init")

      // Constraints already loaded in initializeForm() for both modes
      // Mark flow as ready
      this.markFlowDataReady();
    }).catch((error) => {
      console.error('Error during initialization:', error);
      this.markFlowDataReady();
    });
  }
  // This method is duplicated in multiple forms (objective, Kpi, Measure), all this forms will use form-biz-entity from the framework
  // That is the reason why this method is not added to a serivce.
  private markFlowDataReady(): void {
    this.flowDataReady = true;
    this.tryHideFormLoading();
  }

  private tryHideFormLoading(): void {
    if (this.baseFormReady && this.flowDataReady) {
      this.isFormLoading = false;
    }
  }
  private async initializeForm(): Promise<void> {
    if (this.isEditing) {
      try {
        const deliverableResponse = await this.deliverableStateStoreService.getState(this.bizEntityTypesStateStoresService, undefined, this.kpiStateStoreService, this.measureStateStoreService, [this.deliverableBizEntity.id]);

        this.deliverableBizEntity = deliverableResponse?.[0] || this.deliverableBizEntity;

        // Fetch parent objective to extract duration constraints (edit mode only)
        if (this.deliverableBizEntity.parentId) {
          try {
            // First, fetch the parent entity with full type info including parentPath
            const parentEntities = await this.bizEntityStateStoreService.getState(this.bizEntityTypesStateStoresService, undefined, [this.deliverableBizEntity.parentId]);
            const parentEntity = parentEntities?.[0];

            if (parentEntity) {
              // Now resolve objective from the parent hierarchy
              const parentObjective = await this.bizEntityParentHierarchyService.resolveAndFetchObjectiveFromParentHierarchy(parentEntity);
              if (parentObjective?.duration) {
                this.parentDurationConstraints = this.bizEntityParentHierarchyService.getDurationDisplayValue(parentObjective);
              }
            }
          } catch (error) {
            // Parent not found or not an objective - no constraints
            this.parentDurationConstraints = null;
          }
        }

        if (this.deliverableBizEntity?.kpis && Array.isArray(this.deliverableBizEntity.kpis)) {
          this.deliverableBizEntity.kpis.forEach(kpi => {
            // Assign KPI to appropriate category variable
            this.setKpiObject(kpi);

            // Mark as not auto-created since it already exists
            if (kpi.category === KPIAndMeasureCategories.Progress) {
              this.isAutoKPI[KPIAndMeasureCategories.Progress] = false;
            }
            if (kpi.category === KPIAndMeasureCategories.Performance) {
              this.isAutoKPI[KPIAndMeasureCategories.Performance] = false;
            }
            if (kpi.category === KPIAndMeasureCategories.Quality) {
              this.isAutoKPI[KPIAndMeasureCategories.Quality] = false;
            }
            if (kpi.category === KPIAndMeasureCategories.Innovation) {
              this.isAutoKPI[KPIAndMeasureCategories.Innovation] = false;
            }
          });
        }

        // AWAIT plan loading - ensures plan data is loaded before form builds
        const planData = await this.planStateStoreService.getState([this.deliverableBizEntity?.id.toString()]);
        if (planData) {
          this.plan = planData[0];
        }

        // AWAIT relationship loading - ensures relationship data is loaded before form builds
        if (this.doesBizEntityHaveRelationship()) {
          const relationshipData = await this.relationshipStateStoreService?.getState([this.deliverableBizEntity?.id.toString() || ''], this.bizEntityTypesStateStoresService, this.benBizEntityStateStoreService, undefined, true);
          if (relationshipData) {
            // Extract target biz entities from the relationship data
            this.extractedTargetBizEntities = this.extractTargetBizEntities(relationshipData);
          }
        }
        //  this.loggerService.info(`Editing Deliverable: `,this.deliverableBizEntity);
      } catch (error) {
        this.toastService.toast('Error occured while loading deliverable data');
      }
    } else {
      // Create mode - load biz entities and parent constraints
      try {
        const data = await this.bizEntityStateStoreService.getState(this.bizEntityTypesStateStoresService);
        if (data) {
          this.benBizEntites = data;
        }

        // Fetch parent objective to extract duration constraints (create mode with parent)
        if (this.deliverableBizEntity.parentId) {
          try {
            // First, fetch the parent entity with full type info including parentPath
            const parentEntities = await this.bizEntityStateStoreService.getState(this.bizEntityTypesStateStoresService, undefined, [this.deliverableBizEntity.parentId]);
            const parentEntity = parentEntities?.[0];

            if (parentEntity) {
              // Now resolve objective from the parent hierarchy
              const parentObjective = await this.bizEntityParentHierarchyService.resolveAndFetchObjectiveFromParentHierarchy(parentEntity);
              if (parentObjective?.duration) {
                this.parentDurationConstraints = this.bizEntityParentHierarchyService.getDurationDisplayValue(parentObjective);

                // Update objective summary for display
                this.objectiveSummary = {
                  name: parentObjective.name || '',
                  ...this.bizEntityParentHierarchyService.getDurationDisplayValue(parentObjective),
                };
              }
            }
          } catch (error) {
            // Parent not found or not an objective - no constraints
            this.parentDurationConstraints = null;
            this.objectiveSummary = null;
          }
        }
      } catch (error) {
        this.toastService.toast('Error occured while loading biz entities');
      }
    }
  }
  private buildFormLayout() {
    const layoutContent: IFormLayoutContent = this.buildFormLayoutContent();
    const layout: IFormLayout = {
      content: layoutContent,
    }
    this.formLayout = layout;
  }
  private buildFormFooterLayout() {
    const layoutFooterContent: IFormLayoutContent = {
      fieldItems: [],
    }
    const layoutFooter: IFormLayoutFooter = {
      actions: [{
        label: this.isEditing ? `Update ${this.deliverableBizEntity?.name}` : `Create ${this.deliverableBizEntity?.type?.name}`,
        icon: this.isEditing ? 'cilCheckAlt' : 'cilPlus',
      }]
    }
    const layoutFooterMain: IFormLayout = {
      content: layoutFooterContent,
      footer: layoutFooter,
    }
    return layoutFooterMain;
  }
  private buildFormLayoutContent(): IFormLayoutContent {
    const content: IFormLayoutContent = {
      fieldItems: this.buildFormFields(),
    }
    return content;
  }
  //This method is to collect the data when the user fills it and submit it 
  private populateBizEntityFormWithValues(): IDeliverable {
    const dateRangeField = this.formLayout.content?.fieldItems?.find(field => field.id === 'duration');
    this.deliverableBizEntity.duration = new DateRange(
      new Date(dateRangeField?.dateRangeValueFromString || ''),
      new Date(dateRangeField?.dateRangeValueToString || '')
    );
    // ?? instead of || so that 0 is treated as a valid value (0 || 100 would wrongly give 100)
    const startValueField = this.formLayout.content?.fieldItems?.find(field => field.id === 'start-value')?.value ?? 0;
    const targetValueField = this.formLayout.content?.fieldItems?.find(field => field.id === 'target-value')?.value ?? 100;
    const unitField = this.formLayout.content?.fieldItems?.find(field => field.id === 'unit-value')?.value;
    const isCompletedField = this.formLayout.content?.fieldItems?.find(field => field.id === 'is-completed');

    this.deliverableBizEntity.value = new ValueRange(Number(startValueField), Number(targetValueField));
    if (unitField) {
      this.deliverableBizEntity.unit = Units.find(u => u.symbol === unitField) || this.deliverableBizEntity.unit;
    }
    this.deliverableBizEntity.isCompleted = isCompletedField?.value || false;
    this.mergeAdditionalInfoValues();
    this.mergeBaseBizEntityValues();
    // this.mergeRelationshipValues();
    if (!this.plan) {
      this.autoGeneratePlan();
    }
    return this.deliverableBizEntity;
  }
  private mergeAdditionalInfoValues(): void {
    this.deliverableBizEntity.additionalInfo = this.additionalInfoFormComponent?.additionalInfoFormValues || [];
  }
  private mergeBaseBizEntityValues(): void {
    this.deliverableBizEntity.name = this.baseEntityFormComponent.bizEntityFormValues?.name || '';
    this.deliverableBizEntity.description = this.baseEntityFormComponent.bizEntityFormValues?.description || '';
    this.deliverableBizEntity.icon = this.baseEntityFormComponent.bizEntityFormValues?.icon || '';
    this.deliverableBizEntity.parentId = this.baseEntityFormComponent.bizEntityFormValues?.parentId || '25828';
    this.deliverableBizEntity.ownerId = this.baseEntityFormComponent.bizEntityFormValues?.ownerId || '';
  }

  onParentEntitySet(parentEntity: IBizEntity | null): Promise<void> {
    if (!parentEntity) {
      // Parent cleared - reset constraints and objective summary, rebuild form
      this.parentDurationConstraints = null;
      this.objectiveSummary = null;
      this.buildFormLayout();
      this.markFlowDataReady();
      return Promise.resolve();
    }

    // Load parent objective data asynchronously
    // Reset flow data flag and show loading state
    this.flowDataReady = false;
    this.isFormLoading = true;

    return this.bizEntityParentHierarchyService.resolveAndFetchObjectiveFromParentHierarchy(parentEntity)
      .then((objective) => {
        // Extract duration constraints from parent objective
        this.parentDurationConstraints = objective?.duration
          ? this.bizEntityParentHierarchyService.getDurationDisplayValue(objective)
          : null;

        // Update objective summary for display
        if (objective?.duration) {
          this.objectiveSummary = {
            name: objective.name || '',
            ...this.bizEntityParentHierarchyService.getDurationDisplayValue(objective),
          };
        } else {
          this.objectiveSummary = null;
        }
      })
      .catch(() => {
        // Handle error silently - no constraints
        this.parentDurationConstraints = null;
        this.objectiveSummary = null;
      })
      .finally(() => {
        // Rebuild form with updated constraints (or lack thereof)
        this.buildFormLayout();

        // Regenerate plan when parent changes (dates may change due to new constraints)
        if (this.dateRangePolyControlMeta.dateRangeValueFromString &&
          this.dateRangePolyControlMeta.dateRangeValueToString) {
          this.autoGeneratePlan();
        }

        this.markFlowDataReady();
      });
  }

  onFormReady(): void {
    this.baseFormReady = true;
    this.tryHideFormLoading();
  }
  // NOTE: Relationships are no longer handled through the entity payload, it is safe to remove but still keeping the code for reference. Can remove once tested thoroughly -@adithyasasi (11 Sep 2026)
  // private mergeRelationshipValues(): void {
  //   // console.log("Merging relationship values...");

  //   if (!this.relationshipFieldsComponents || this.relationshipFieldsComponents.length === 0) {
  //     // console.log("No relationship field components found");
  //     return;
  //   }
  //   // Collect relationship data from all relationship field components using the getter
  //   const relationshipsData: Array<{
  //     relationshipKey: string;
  //     config: IRelationshipConfiguration;
  //     data: IAdditionalInfo[]
  //   }> = [];
  //   this.relationshipFieldsComponents.forEach((component, index) => {
  //     if (!component.config) {
  //       return;
  //     }
  //     const relationshipValues = component.relationshipFormValues;
  //     const target = component.config.target as IBizEntityType;
  //     const relationshipKey = target?.name || `relationship_${index}`;
  //     relationshipsData.push({
  //       relationshipKey: relationshipKey,
  //       config: component.config,
  //       data: relationshipValues
  //     });

  //     // console.log(`Collected relationship data for ${relationshipKey}:`, relationshipValues);
  //   });
  //   // Attach relationship data to deliverable entity
  //   // if (relationshipsData.length > 0) {
  //   //   (this.deliverableBizEntity as any).relationshipData = relationshipsData;
  //   //   // console.log("Final relationship data attached to deliverable:", relationshipsData);
  //   // }
  // }
  private autoGeneratePlan(): void {
    this.planFormComponent.generatePlan();
  }
  private doesBizEntityHaveRelationship(): boolean {
    // console.log("Checking relationship configuration for deliverable type:", this.deliverableBizEntity?.type);
    if (this.deliverableBizEntity?.type && this.deliverableBizEntity.type.relationshipConfiguration && this.deliverableBizEntity.type.relationshipConfiguration.length > 0) {
      this.relationshipConfigurations = this.deliverableBizEntity.type.relationshipConfiguration;
      // console.log("Relationship configurations:", this.relationshipConfigurations);
      return true;
    }
    return false;
  }
  get currentBizEntity(): IDeliverable {
    return this.deliverableBizEntity;
  }
  getStartValue() {
    const startValueField = this.formLayout?.content?.fieldItems?.find(field => field.id === 'start-value');
    const startValue = startValueField?.value !== undefined ? Number(startValueField.value) : (this.deliverableBizEntity?.value?.start ?? 0);
    // console.log('getStartValue called - field value:', startValueField?.value, 'entity value:', this.deliverableBizEntity?.value?.start, 'returning:', startValue);
    return startValue;
  }
  getTargetValue() {
    const targetValueField = this.formLayout?.content?.fieldItems?.find(field => field.id === 'target-value');
    const endValue = targetValueField?.value !== undefined ? Number(targetValueField.value) : (this.deliverableBizEntity?.value?.target ?? 100);
    // console.log('getTargetValue called - field value:', targetValueField?.value, 'entity value:', this.deliverableBizEntity?.value?.target, 'returning:', endValue);
    return endValue;
  }
  dateRangePolyControlMeta: IPolymorphicControlMeta = this.polymorphicControlService.getC();

  private prepareDateRangeFieldMeta(): IPolymorphicControlMeta {
    this.dateRangePolyControlMeta.id = 'duration';
    this.dateRangePolyControlMeta.icon = "cilCalendar";
    this.dateRangePolyControlMeta.type = this.polymorphicControlService.getPolyControlFromFieldType(FieldTypes.rangeDate);
    this.dateRangePolyControlMeta.label = "Start Date - End Date";

    // Populate with actual loaded data (if available in edit mode)
    // IMPORTANT: Set BOTH Date objects AND string values - constraint service reads Date objects!
    this.dateRangePolyControlMeta.dateRangeValueFrom = this.deliverableBizEntity?.duration?.from;
    this.dateRangePolyControlMeta.dateRangeValueTo = this.deliverableBizEntity?.duration?.to;
    this.dateRangePolyControlMeta.dateRangeValueFromString = this.deliverableBizEntity?.duration?.from
      ? this.utilService.convertDateToString(this.deliverableBizEntity.duration.from)
      : '';
    this.dateRangePolyControlMeta.dateRangeValueToString = this.deliverableBizEntity?.duration?.to
      ? this.utilService.convertDateToString(this.deliverableBizEntity.duration.to)
      : '';
    this.dateRangePolyControlMeta.value = this.deliverableBizEntity?.duration?.from && this.deliverableBizEntity?.duration?.to
      ? {
        from: this.utilService.convertDateToString(this.deliverableBizEntity.duration.from),
        to: this.utilService.convertDateToString(this.deliverableBizEntity.duration.to),
      }
      : { from: '', to: '' };

    this.dateRangePolyControlMeta.fieldMeta = {
      id: 1,
      name: 'Duration',
      type: FieldTypes.rangeDate,
      label: 'Duration Field',
      isRequired: true,
    };

    /**
     * ⚠️⚠️⚠️ BUSINESS RULES NOTICE ⚠️⚠️⚠️
     * These are business rules. Should be loaded by
     * code at runtime and handled as data, not as logic.
     * ⚠️⚠️⚠️ BUSINESS RULES NOTICE ⚠️⚠️⚠️
     */
    // Apply parent duration constraints if they exist (from parent objective)
    if (this.parentDurationConstraints) {
      const constrained = this.durationConstraintsService.applyDurationConstraints(
        this.dateRangePolyControlMeta,
        this.parentDurationConstraints,
        'Deliverable'
      );
      // Sync the reference so both dateRangePolyControlMeta and formLayout point to the same object
      // This ensures plan form's ngOnChanges detects date updates when user manually picks dates
      this.dateRangePolyControlMeta = constrained;
      return constrained;
    }

    return this.dateRangePolyControlMeta;
  }

  // NOTE: This method is no longer needed after refactoring to load data BEFORE building form
  // Previously used to patch values into an already-built form (workaround for wrong initialization order)
  // Now the form is built with loaded data from the start, eliminating the need for manual patching

  // lets remove it once fully confident (31 Aug - @adithyasasi)

  // patchValuesOnEdit() {
  //   if (!this.isEditing || !this.deliverableBizEntity) {
  //     return;
  //   }

  //   // console.log('Patching form values for edit mode:', this.deliverableBizEntity);

  //   // Patch date range values
  //   let durationField = this.formLayout.content?.fieldItems?.find(field => field.id === 'duration');
  //   if (durationField && this.deliverableBizEntity.duration) {
  //     const fromDateString = this.deliverableBizEntity.duration.from ?
  //       this.utilService.convertDateToString(this.deliverableBizEntity.duration.from) : '';
  //     const toDateString = this.deliverableBizEntity.duration.to ?
  //       this.utilService.convertDateToString(this.deliverableBizEntity.duration.to) : '';
  //     // Update both the form field and the dateRangePolyControlMeta object
  //     durationField.dateRangeValueFromString = fromDateString;
  //     durationField.dateRangeValueToString = toDateString;
  //     // Update the dateRangePolyControlMeta used in HTML template
  //     this.dateRangePolyControlMeta.dateRangeValueFromString = fromDateString;
  //     this.dateRangePolyControlMeta.dateRangeValueToString = toDateString;
  //     this.dateRangePolyControlMeta.value =  this.deliverableBizEntity?.duration?.from && this.deliverableBizEntity?.duration?.to ? `${this.utilService.convertDateToString(this.deliverableBizEntity.duration.from)} - ${this.utilService.convertDateToString(this.deliverableBizEntity.duration.to)}` : '';
  //     // console.log('Patched duration field:', durationField);
  //     // console.log('Updated dateRangePolyControlMeta:', this.dateRangePolyControlMeta);
  //   }
  //   let unitField = this.formLayout.content?.fieldItems?.find(field => field.id === 'unit-value');
  //   if(unitField && this.deliverableBizEntity.unit) {
  //     unitField.value = this.deliverableBizEntity.unit.symbol || '';
  //     unitField.optionSelected = `${this.deliverableBizEntity.unit.name} (${this.deliverableBizEntity.unit.symbol})`;
  //      unitField.disabled = true
  //     // console.log('Patched unit field:', unitField);
  //   }
  //   // Patch start value
  //   let startValueField = this.formLayout.content?.fieldItems?.find(field => field.id === 'start-value');
  //   if (startValueField && this.deliverableBizEntity.value) {
  //     startValueField.value = this.deliverableBizEntity.value.start.toString() || '0';
  //     // console.log('Patched start value:', startValueField.value);
  //   }
  //   // Patch target value
  //   let targetValueField = this.formLayout.content?.fieldItems?.find(field => field.id === 'target-value');
  //   if (targetValueField && this.deliverableBizEntity.value) {
  //     targetValueField.value = this.deliverableBizEntity.value.target.toString() || '100';
  //     // console.log('Patched target value:', targetValueField.value);
  //   }

  //   // Patch isCompleted value
  //   let isCompletedField = this.formLayout.content?.fieldItems?.find(field => field.id === 'is-completed');
  //   if (isCompletedField) {
  //     isCompletedField.value = this.deliverableBizEntity.isCompleted || false;
  //     // console.log('Patched isCompleted value:', isCompletedField.value);
  //   }

  //   // Trigger plan generation with a small delay to ensure DOM updates
  //   setTimeout(() => {
  //     // console.log('About to trigger plan generation after patch');
  //     this.autoGeneratePlan();
  //   }, 50);
  // }
  //This method builds the form fields for deliverable form
  private buildFormFields(): IPolymorphicControlMeta[] {
    const formFields: IPolymorphicControlMeta[] = []
    const duration: IPolymorphicControlMeta = this.prepareDateRangeFieldMeta();
    const startValue: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'start-value',
      type: PolyMorphicControlTypes.number,
      label: 'Start Value',
      icon: 'cilCalculator',
      value: this.deliverableBizEntity?.value?.start ?? 0,
      placeholder: 'Select start value (0-100)',
      fieldMeta: {
        id: 'start-value',
        name: 'Start Value',
        type: FieldTypes.number,
        label: 'Start Value Field',
        isRequired: true,
      },
    });
    const targetValue: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'target-value',
      type: PolyMorphicControlTypes.number,
      label: 'Target Value',
      icon: 'cilCalculator',
      value: this.deliverableBizEntity?.value?.target ?? 100,
      placeholder: 'Select target value (0-100)',
      fieldMeta: {
        id: 'target-value',
        name: 'Target Value',
        type: FieldTypes.number,
        label: 'Target Value Field',
        isRequired: true,
      },
    });

    const unitValue: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'unit-value',
      type: PolyMorphicControlTypes.options
    });
    unitValue.optionHeader = 'Unit';
    unitValue.icon = 'cilLoop';
    unitValue.label = 'Unit';
    unitValue.floatingLabel = true;
    unitValue.optionsWithIcon = [];
    unitValue.options = Units.map(u => ({
      label: `${u.name} (${u.symbol})`,
      id: u.symbol
    } as IOptionWithoutIcon));

    let selectedUnitOpt: IOptionWithoutIcon | undefined;
    if (this.deliverableBizEntity.unit) {
      selectedUnitOpt = unitValue.options.find(o => o.label.startsWith(this.deliverableBizEntity.unit!.name))
        || unitValue.options.find(o => o.id === this.deliverableBizEntity.unit?.symbol)
        || unitValue.options.find(o => o.label.includes('(%)'))
        || unitValue.options[0];
    } else {
      selectedUnitOpt = unitValue.options.find(o => o.label.includes('(%)')) || unitValue.options[0];
    }

    unitValue.value = selectedUnitOpt?.id || '';
    unitValue.optionSelected = selectedUnitOpt?.label || '';
    unitValue.disabled = this.isEditing && !!this.deliverableBizEntity.unit;
    unitValue.fieldMeta = {
      id: 3,
      name: 'Unit',
      type: FieldTypes.text,
      label: ' Unit Field',
      isRequired: true,
    };
    unitValue.optionChangeCallback = (data: IOptionWithoutIcon) => {
      unitValue.value = data.id;
      unitValue.optionSelected = data.label;
      this.deliverableBizEntity.unit = Units.find(u => u.symbol === data.id) as Unit;
      // this.ProgressKPIunit = this.deliverableBizEntity.unit;
    };
    if (!this.deliverableBizEntity.unit && selectedUnitOpt) {
      this.deliverableBizEntity.unit = Units.find(u => u.symbol === selectedUnitOpt.id) as Unit;
    }

    const isCompletedControl: IPolymorphicControlMeta = this.polymorphicControlService.getC({
      id: 'is-completed',
      type: PolyMorphicControlTypes.checkBox,
      label: 'Mark as Completed',
      icon: 'cilCheckCircle',
      value: this.deliverableBizEntity?.isCompleted || false,
      fieldMeta: {
        id: 'is-completed',
        name: 'Is Completed',
        type: FieldTypes.boolean,
        label: 'Is Completed Field',
        isRequired: false,
      },
    });

    formFields.push(duration);
    formFields.push(startValue);
    formFields.push(targetValue);
    formFields.push(unitValue);
    formFields.push(isCompletedControl);
    return formFields;
  }

  /**
   * Receives generated plan items from the plan form component
   */
  generatedPlan(planItems: iPlan) {
    this.plan = planItems;
  }

  submitPlan(deliverableId: string) {
    if (this.plan) {
      if (!this.plan.deliverableId) this.plan.deliverableId = deliverableId;
      if (this.isEditing) {
        this.planStateStoreService.update(this.plan);
      } else {
        this.planStateStoreService.create(this.plan);
      }
    }
  }

  // This validation can be handled with the isValid property of the polymorphic controls, will refactor later -@adithyasasi
  get isFormValid(): boolean {
    // 1. Validate base entity form (name, description, icon, parent, owner)
    if (this.baseEntityFormComponent && !this.baseEntityFormComponent.isBaseFormValid) {
      return false;
    }

    // 2. Validate deliverable-specific fields (duration, start value, target value)
    if (this.formLayout?.content?.fieldItems) {
      for (const field of this.formLayout.content.fieldItems) {
        if (field.fieldMeta?.isRequired) {
          field.touched = true;

          let fieldValue;

          // Handle rangeDate validation
          if (field.type === PolyMorphicControlTypes.rangeDate) {
            // Check if from date is empty
            if (!field.dateRangeValueFromString || field.dateRangeValueFromString.trim() === '') {
              return false;
            }

            // Check if to date is empty
            if (!field.dateRangeValueToString || field.dateRangeValueToString.trim() === '') {
              return false;
            }

            // Validate that from date is before to date
            const fromDate = new Date(field.dateRangeValueFromString);
            const toDate = new Date(field.dateRangeValueToString);

            // Check if dates are valid
            if (isNaN(fromDate.getTime()) || isNaN(toDate.getTime())) {
              return false;
            }

            // Check if from date is smaller than to date
            if (fromDate >= toDate) {
              return false;
            }

            // Check min/max date constraints if they exist
            if (field.minDate) {
              const minDate = new Date(field.minDate);
              if (!isNaN(minDate.getTime()) && fromDate < minDate) {
                return false;
              }
            }

            if (field.maxDate) {
              const maxDate = new Date(field.maxDate);
              if (!isNaN(maxDate.getTime()) && toDate > maxDate) {
                return false;
              }
            }

            fieldValue = field.value; // Continue with validation
          } else {
            fieldValue = field.value;
          }

          // Check if field is empty (skip for rangeDate as already validated above)
          if (field.type !== PolyMorphicControlTypes.rangeDate) {
            if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
              return false;
            }
          }

          // Check pattern validation
          if (field.fieldMeta.inputPattern && fieldValue) {
            const pattern = new RegExp(field.fieldMeta.inputPattern);
            if (!pattern.test(fieldValue.toString())) {
              return false;
            }
          }

          // Check min/max validation for number fields
          if (field.type === PolyMorphicControlTypes.number && fieldValue !== '') {
            const numValue = Number(fieldValue);

            if (isNaN(numValue)) {
              return false;
            }

            if (field.fieldMeta.min !== undefined && field.fieldMeta.min !== null) {
              if (numValue < field.fieldMeta.min) {
                return false;
              }
            }

            if (field.fieldMeta.max !== undefined && field.fieldMeta.max !== null) {
              if (numValue > field.fieldMeta.max) {
                return false;
              }
            }
          }
        }
      }
    }

    //4. Validate KPI trigger controls - MARK AS TOUCHED FIRST
    for (const kpiControl of this.kpiTriggerControls) {
      kpiControl.touched = true;
    }
    // 5. Validate Progress KPI selection (must be selected or auto-created)
    const hasProgressKPI = !!(
      this.selectProgressionKPIObj ||
      this.isAutoKPI[KPIAndMeasureCategories.Progress]
    );

    if (!hasProgressKPI) {
      return false;
    }

    // 6. Validate KPI trigger controls (only if not auto-created and no other KPI selected)
    for (const kpiControl of this.kpiTriggerControls) {
      kpiControl.touched = true;
      if (kpiControl.fieldMeta?.isRequired && !kpiControl.disabled) {
        const fieldValue = kpiControl.selectedBizEntity || kpiControl.value;

        if (!fieldValue || fieldValue === '') {
          return false;
        }
      }
    }

    if (!this.planFormComponent?.isPlanFormValid) {
      return false;
    }

    if (this.deliverableBizEntity?.type?.additionalFields?.length > 0) {
      const isAdditionalInfoValid = this.additionalInfoFormComponent?.isAdditionalInfoValid || false;
      if (!isAdditionalInfoValid) {
        return false;
      }
    }

    if (this.relationshipFieldsComponents?.length > 0) {
      const allRelationshipsValid = this.relationshipFieldsComponents.toArray().every(rf => rf.isFormValid());
      if (!allRelationshipsValid) {
        return false;
      }
    }

    return true;
  }

  autoCreateEntitiesFirst = false;

  onDeliverableSave(): void {
    if (!this.isFormValid) {
      this.toastService.toast('Please fill all required fields.');
      return;
    }

    // Validate Progress KPI is mandatory
    if (!this.isAutoKPI[KPIAndMeasureCategories.Progress] && !this.selectProgressionKPIObj) {
      this.toastService.toast('Progress KPI is mandatory. Please select a KPI or enable auto-creation.');
      return;
    }

    if (this.isAPICallInProgress) {
      this.toastService.toast('Please wait, operation in progress.');
      return;
    }

    this.setAPICallInProgress(true);
    this.populateBizEntityFormWithValues();
    if (this.isEditing) {
      this.populateDeliverableKPIs(this.deliverableBizEntity);
      this.deliverableStateStoreService.update(this.deliverableBizEntity)?.then(async (response) => {
        this.submitPlan(this.deliverableBizEntity?.id);
        this.appStateService.incomingBizEntitySelectionId = response['bizEntityId'] ? String(response['bizEntityId']) : null;
        this.baseEntityFormComponent.afterSubmissionSucceeded();
        if (this.doesHaveRelationship()) {
          await this.handleEditRelationships();
        }
        this.setAPICallInProgress(false);
      }).catch((error) => {
        this.toastService.toast('Error occurred while updating deliverable');
        this.setAPICallInProgress(false);
      });
    } else {
      this.autoCreateEntitiesFirst = Object.keys(this.isAutoKPI).some((key) => this.isAutoKPI[key as unknown as KPIAndMeasureCategories]);
      // console.log('Auto Create Entities First:', this.autoCreateEntitiesFirst);
      if (this.autoCreateEntitiesFirst) {
        this.createKPIAutomatically(this.isAutoKPI).then((response) => {
          // console.log('Automatically created KPIs:', response);
          this.handleDeliverableSubmission();
        })
      }
      else {
        this.handleDeliverableSubmission();
      }


    }
  }
  //This sends data to the api to create deliverable
  handleDeliverableSubmission = () => {
    this.populateDeliverableKPIs(this.deliverableBizEntity);
    // console.log('Creating deliverable:', this.deliverableBizEntity);
    if (this.deliverableBizEntity) {
      if (this.doesHaveRelationship()) {
        this.retrieveAdditionalEntityDetails();
      }
      else {
        this.deliverableStateStoreService.create(this.deliverableBizEntity)?.then((response) => {
          //   console.log("Created deliverable ID:", response)
          notifyStrategyEntityCreated(this.deliverableBizEntity, response, () => {
            this.appStateService.incomingBizEntitySelectionId = response['bizEntityId'] ? String(response['bizEntityId']) : null;
          });
          this.submitPlan(response.biz_entity_id);
          this.baseEntityFormComponent.afterSubmissionSucceeded();
          this.setAPICallInProgress(false);
        }).catch((error) => {
          this.toastService.toast('Error occured while creating deliverable');
          this.setAPICallInProgress(false);
        });
      }
    }
  }
  private populateDeliverableKPIs(bizEntity: IDeliverable) {
    // console.log('Populating deliverable KPIs before submission...', this.selectProgressionKPIObj);
    // Rebuild kpis array from selected category objects to ensure proper replacement
    bizEntity.kpis = [];

    if (this.selectProgressionKPIObj) {
      bizEntity.kpis.push(this.selectProgressionKPIObj);
    }
    if (this.selectPerformanceKPIObj) {
      bizEntity.kpis.push(this.selectPerformanceKPIObj);
    }
    if (this.selectQualityKPIObj) {
      bizEntity.kpis.push(this.selectQualityKPIObj);
    }
    if (this.selectInnovationKPIObj) {
      bizEntity.kpis.push(this.selectInnovationKPIObj);
    }
    // console.log("---KPI DATA--",this.selectProgressionKPIObj,this.selectPerformanceKPIObj,this.selectQualityKPIObj,this.selectInnovationKPIObj)
    // console.log('---Populated deliverable KPIs:----', bizEntity.kpis);
    // console.log('bizEntity.kpis', bizEntity.kpis);
    bizEntity.kpis = bizEntity.kpis.filter(kpi => kpi !== null && kpi !== undefined);
    // this.checkFormValidity(bizEntity);
  }
  setAutoKPIState(event?: Event, category?: KPIAndMeasureCategories, markAll?: boolean) {
    const isChecked = event ? (event.target as HTMLInputElement).checked : false;
    if (markAll !== undefined) {
      Object.keys(KPIAndMeasureCategories).forEach((key) => {
        const cat = KPIAndMeasureCategories[key as keyof typeof KPIAndMeasureCategories];
        // if(cat === KPIAndMeasureCategories.Progress || cat === KPIAndMeasureCategories.Performance || cat === KPIAndMeasureCategories.Quality || cat === KPIAndMeasureCategories.Innovation){
        //   this.isAutoKPI[cat] = markAll;
        // }
        if (cat === KPIAndMeasureCategories.Progress) {
          this.isAutoKPI[cat] = markAll;
        }
      });
    } else if (category) {
      this.isAutoKPI[category] = isChecked;
    } else {
      const categoriesToEnable = [
        KPIAndMeasureCategories.Progress,
        // KPIAndMeasureCategories.Performance,
        // KPIAndMeasureCategories.Quality,
        // KPIAndMeasureCategories.Innovation,
      ];
      categoriesToEnable.forEach((cat) => {
        this.isAutoKPI[cat] = isChecked;
      });
    }

    let unitField = this.formLayout.content?.fieldItems?.find(field => field.id === 'unit-value');
    if (unitField) {
      unitField.disabled = !this.isAutoKPI[this.KPICategory.Progress];
    }
    this.buildKpiTriggerControls()
  }
  getEntityTypeNameBasedOnCategory(category: KPIAndMeasureCategories): string {
    switch (category) {
      case KPIAndMeasureCategories.Progress:
        return "Progress KPI";
      case KPIAndMeasureCategories.Performance:
        return "Performance KPI";
      case KPIAndMeasureCategories.Quality:
        return "Quality KPI";
      case KPIAndMeasureCategories.Innovation:
        return "Innovation KPI";
      default:
        return "Progress KPI";
    }
  }
  populateKPIId(data: IBizEntity) {
    // comsole.log("populateKPIId data:",data);
    let KPIData = data as IKPI;
    this.setKpiObject(KPIData);
  }
  private buildKpiTriggerControls(): void {

    const progressTrigger = this.polymorphicControlService.getC({
      type: PolyMorphicControlTypes.trigger,
      label: 'Progression KPI',
      icon: 'cilLayers',
      value: this.selectProgressionKPIObj || '',
      floatingLabel: true,
      placeholder: this.isAutoKPI[this.KPICategory.Progress] ? 'KPI will be automatically created' : 'Click to select Progression KPI',
      disabled: this.isAutoKPI[this.KPICategory.Progress],
      selectedBizEntity: this.selectProgressionKPIObj,
      fieldMeta: {
        id: 'progress-kpi-trigger',
        name: 'Progress KPI Trigger',
        type: FieldTypes.bizEntity,
        label: 'Progress KPI Field',
        isRequired: !this.isAutoKPI[this.KPICategory.Progress],
      },
      //NEED TO BE FIXED RIGHT NOW HARDCODED JUST TO RUN THE FUNCTIONALITY @Yash-optimaStride
      //
      //
      explorerSelected: Explorers.KPI.toString(),
      executeClickCallback: () => {
        if (!this.isAutoKPI[this.KPICategory.Progress]) {
          this.appStateService.selectedKPIAndMeasureCategory = KPIAndMeasureCategories.Progress;
          launchExplorerDialog(progressTrigger, this.optimaDefaultModalService, (data: IKPI) => {
            this.populateKPIId(data);
            this.buildKpiTriggerControls();
            if (data.unit) { this.deliverableBizEntity.unit = data.unit; }

            // this.ProgressKPIunit = data.unit;
            let unitField = this.formLayout.content?.fieldItems?.find(field => field.id === 'unit-value');
            if (unitField) {
              unitField.value = data.unit?.symbol || '';
              unitField.optionSelected = `${data.unit?.name} (${data.unit?.symbol})`;
              // console.log('Patched unit field:', unitField);
              unitField.disabled = true
            }

          })
        }

        // this.openKPIChooser(this.KPICategory.Progress);
      }
    });
    // comsole.log("progressTrigger",this.selectProgressionKPIObj?.name || (this.isAutoKPI[this.KPICategory.Progress] ? 'KPI will be automatically created' : ''))
    const performanceTrigger = this.polymorphicControlService.getC({
      type: PolyMorphicControlTypes.trigger,
      label: 'Performance KPI',
      icon: 'cilLayers',
      value: this.selectPerformanceKPIObj || '',
      floatingLabel: true,
      placeholder: this.isAutoKPI[this.KPICategory.Performance] ? 'KPI will be automatically created' : 'Click to select Performance KPI',
      disabled: this.isAutoKPI[this.KPICategory.Performance],
      selectedBizEntity: this.selectPerformanceKPIObj,
      explorerSelected: Explorers.KPI.toString(),
      fieldMeta: {
        id: 'performance-kpi-trigger',
        name: 'Performance KPI Trigger',
        type: FieldTypes.bizEntity,
        label: 'Performance KPI Trigger Field',
        isRequired: false,
      },
      executeClickCallback: () => {
        if (!this.isAutoKPI[this.KPICategory.Performance]) {
          this.appStateService.selectedKPIAndMeasureCategory = KPIAndMeasureCategories.Performance;
          launchExplorerDialog(performanceTrigger, this.optimaDefaultModalService, (data: IKPI) => {
            this.populateKPIId(data);
            this.buildKpiTriggerControls();
          })
        }
      }
    });
    const qualityTrigger = this.polymorphicControlService.getC({
      type: PolyMorphicControlTypes.trigger,
      label: 'Quality KPI',
      icon: 'cilLayers',
      value: this.selectQualityKPIObj || '',
      floatingLabel: true,
      placeholder: this.isAutoKPI[this.KPICategory.Quality] ? 'KPI will be automatically created' : 'Click to select Quality KPI',
      disabled: this.isAutoKPI[this.KPICategory.Quality],
      selectedBizEntity: this.selectQualityKPIObj,
      fieldMeta: {
        id: 'quality-kpi-trigger',
        name: 'Quality KPI Trigger',
        type: FieldTypes.bizEntity,
        label: 'Quality KPI Trigger Field',
        isRequired: false,
      },
      explorerSelected: Explorers.KPI.toString(),
      executeClickCallback: () => {
        if (!this.isAutoKPI[this.KPICategory.Quality]) {
          this.appStateService.selectedKPIAndMeasureCategory = KPIAndMeasureCategories.Quality;
          launchExplorerDialog(qualityTrigger, this.optimaDefaultModalService, (data: IKPI) => {
            this.populateKPIId(data);
            this.buildKpiTriggerControls();
          });

        }

      }
    });

    const innovationTrigger = this.polymorphicControlService.getC({
      type: PolyMorphicControlTypes.trigger,
      label: 'Innovation KPI',
      icon: 'cilLayers',
      value: this.selectInnovationKPIObj || '',
      floatingLabel: true,
      placeholder: this.isAutoKPI[this.KPICategory.Innovation] ? 'KPI will be automatically created' : 'Click to select Innovation KPI',
      disabled: this.isAutoKPI[this.KPICategory.Innovation],
      selectedBizEntity: this.selectInnovationKPIObj,
      explorerSelected: Explorers.KPI.toString(),
      fieldMeta: {
        id: 'innovation-kpi-trigger',
        name: 'Innovation KPI Trigger',
        type: FieldTypes.bizEntity,
        label: 'Innovation KPI Trigger Field',
        isRequired: false,
      },
      executeClickCallback: () => {
        if (!this.isAutoKPI[this.KPICategory.Innovation]) {
          this.appStateService.selectedKPIAndMeasureCategory = KPIAndMeasureCategories.Innovation;
          launchExplorerDialog(innovationTrigger, this.optimaDefaultModalService, (data: IKPI) => {
            this.populateKPIId(data);
            this.buildKpiTriggerControls();
          })
        }
      }
    });
    this.kpiTriggerControls = [progressTrigger]//, performanceTrigger, qualityTrigger, innovationTrigger];
  }


  //THis will be removed
  onKpiTriggerValueChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
  }
  setKpiObject(kpi: IKPI) {
    if (kpi.category === KPIAndMeasureCategories.Progress) {
      this.selectProgressionKPIObj = kpi;
    }
    if (kpi.category === KPIAndMeasureCategories.Performance) {
      this.selectPerformanceKPIObj = kpi;
    }
    if (kpi.category === KPIAndMeasureCategories.Quality) {
      this.selectQualityKPIObj = kpi;
    }
    if (kpi.category === KPIAndMeasureCategories.Innovation) {
      this.selectInnovationKPIObj = kpi;
    }
  }

  /**
   * Creates KPIs automatically based on the selected categories
   * @param isAutoKPI - Record of KPI categories flagged for automatic creation
   */
  createKPIAutomatically(isAutoKPI: Record<KPIAndMeasureCategories, boolean>): Promise<void> {
    return this.bizEntityTypesStateStoresService.getState().then((data) => {

      if (!data) {
        throw new Error("State data is missing.");
      }
      const kpiPromises: Promise<void>[] = [];
      Object.keys(isAutoKPI).forEach((key) => {
        const category = key as unknown as KPIAndMeasureCategories;
        if (isAutoKPI[category]) {
          let entityTypeNameBasedonCategory = this.getEntityTypeNameBasedOnCategory(category);
          let kpiBizEntityType = data.find(entity => {
            //console.log("line 558", entity, entityTypeNameBasedonCategory);
            return entity.isSystemType && entity.category === BizEntityTypeCategory.BenzaitenKPI
          });
          let measureBizEntityType = data.find(entity => entity.isSystemType && entity.category === BizEntityTypeCategory.BenzaitenMeasure);
          //When user is coming for the first time that is why the api is called becasue we need data to find kpi parent id and measure parent id 
          // need to ask to @mudit-OptimaStride weather it is correct or not because earlier it was done the same way
          let kpiParentId = this.benBizEntites.find(entity => entity.type.isSystemType && entity.type.category === BizEntityTypeCategory.BenzaitenKPIAutoStore)?.id.toString();
          let measureParentId = this.benBizEntites.find(entity => entity.type.isSystemType && entity.type.category === BizEntityTypeCategory.BenzaitenMeasureAutoStore)?.id.toString();
          const unitOptionSelected = this.formLayout.content?.fieldItems?.find(field => field.id === 'unit-value')?.value;
          if (unitOptionSelected) {
            const match = unitOptionSelected.match(/\(([^)]+)\)$/);
            const symbol = match ? match[1] : unitOptionSelected.split(' ')[0];

            this.deliverableBizEntity.unit = Units.find(u => u.symbol === symbol) || this.deliverableBizEntity.unit;
            //  this.ProgressKPIunit = this.deliverableBizEntity.unit;
          }
          if (kpiParentId && measureParentId && kpiBizEntityType && measureBizEntityType) {
            let kpiCreationPromise = this.autoCreateEntitiesService
              .createKPIAutomatically(
                kpiBizEntityType,
                measureBizEntityType,
                kpiParentId,
                measureParentId,
                this.deliverableBizEntity.name || '',
                this.deliverableBizEntity.ownerId || '',
                Number(category),
                this.deliverableBizEntity.unit,
                this.deliverableBizEntity.duration
              )
              .then((response: any) => {
                return this.kpiStateStoreService.getState(this.bizEntityTypesStateStoresService, this.measureStateStoreService)
                  .then((data) => {
                    if (data) {
                      this.kpi = data;
                    }
                    let autoCreatedKPI = this.kpi.find(k => k.id === response.biz_entity_id);
                    if (autoCreatedKPI) {
                      this.setKpiObject(autoCreatedKPI);
                    }
                  });
              });
            kpiPromises.push(kpiCreationPromise);
          }
        }
      });
      return Promise.all(kpiPromises).then(() => {
      });
    });
  }
  getTargetBizEntity(config: IRelationshipConfiguration): IBizEntity[] {
    if (config?.targetType === RelationshipTargetType.BizEntityType) {
      return this.extractedTargetBizEntities.filter(
        bizEntity => bizEntity.type?.id.toString() === (config.target as IBizEntityType).id.toString() ||
          bizEntity.type?.basedOnTypeId?.toString() === (config.target as IBizEntityType).id?.toString()
      );
    } else {
      return this.extractedTargetBizEntities.filter(
        bizEntity => bizEntity.type?.category === (config.target as BizEntityTypeCategory)
      );
    }
  }
  onBizEntityAdditionalInfo(data: { config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[] }[], index: number): void {
    // Since the component now emits an array of blocks/selections for each relationship config,
    // we need to flatten and store all entries. Remove old entries for this config first.
    this.relationshipAdditionalInfo = this.relationshipAdditionalInfo.filter(
      item => item.config !== data[0]?.config
    );
    // Add all new entries
    this.relationshipAdditionalInfo.push(...data);
  }

  /// This emit is only declared in the form-relationship at framework but not actually emitted i.e it will never get fired
  /// Will need to review what this was intended for - @adithyasasi (10 Sep 2026)
  onBizEntityAdditionalInfoForEdit(data: { config: IRelationshipConfiguration, bizEntity: IBizEntity }) {
    this.relationshipAdditionalInfoForEdit.push(data);
  }

  private async handleEditRelationships(): Promise<void> {
    this.relationshipFieldsComponents?.forEach(rf => rf.getRelationshipFormFieldValues());
    if (this.relationshipAdditionalInfo.length === 0) return;

    const registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
    for (const data of this.relationshipAdditionalInfo) {
      if (data.config.targetType !== RelationshipTargetType.BizEntityType) continue;
      if (!this.deliverableBizEntity) continue;

      if (data.config.link === RelationshipLinkType.Tight) {
        const entityParentId = await this.getEntityParentIdForTightlyLinkedEntity(data.config, this.deliverableBizEntity);
        const tightlyLinkedBizEntity = this.autoCreateEntitiesService.createBizEntityAutomaticallyFromBizEntity(this.deliverableBizEntity, data.name, data.additionalInfo, data.config, entityParentId);
        const tightlyLinkedCategory = tightlyLinkedBizEntity.type.category;
        (tightlyLinkedBizEntity as IDeliverable & { appId?: string; tenantId?: string }).appId = (tightlyLinkedBizEntity as IDeliverable).appId;
        (tightlyLinkedBizEntity as IDeliverable & { appId?: string; tenantId?: string }).tenantId = (tightlyLinkedBizEntity as IDeliverable).tenantId;
        const transformedTightlyLinked = benBizEntitySyncBeforeSendingToAPI(tightlyLinkedBizEntity as IBenBizEntity, this.userContextService);
        registeredRelationshipRecords.push({
          relationshipType: data.config.relationshipType,
          target: { isNew: true, bizEntity: transformedTightlyLinked, category: tightlyLinkedCategory },
        });
      } else {
        data.additionalInfo.forEach((addInfo: IAdditionalInfo & { selectedBizEntity?: IBizEntity }) => {
          if (addInfo.fieldMeta.type === FieldTypes.bizEntity && addInfo.value) {
            const bizEntity = addInfo.selectedBizEntity || this.bizEntities.find(be => be.id.toString() === addInfo.value.toString());
            if (bizEntity) {
              registeredRelationshipRecords.push({
                relationshipType: data.config.relationshipType,
                target: { isNew: false, bizEntity: bizEntity.id, category: bizEntity?.type?.category },
              });
            }
          }
        });
      }
    }

    if (registeredRelationshipRecords.length === 0) return;

    const relations: IBizEntityRelationships = {
      from: { isNew: false, bizEntity: this.deliverableBizEntity.id, category: this.deliverableBizEntity.type.category },
      to: registeredRelationshipRecords,
    };
    await this.relationshipStateStoreService.create(relations, false)?.catch((error) => {
      this.toastService.toast(`Error updating relationships: ${error}`);
    });
  }

  async retrieveAdditionalEntityDetails() {
    // REFACTOR: we are using two different method for same thing `doesHaveRelationship()` and `doesBizEntityHaveRelationship()` -@adithyasasi 
    // doesBizEntityHaveRelationship() also mutates the `relationshipConfigurations`
    if (!this.deliverableBizEntity || !this.doesBizEntityHaveRelationship()) {
      this.setAPICallInProgress(false);
      return;
    }
    if (this.isRelationshipAdditionalInfoValid()) {
      if (!this.isEditing) {
        let registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
        for (const data of this.relationshipAdditionalInfo) {
          let targetType = data.config.targetType;
          if (targetType === RelationshipTargetType.BizEntityType) {
            // if (!this.deliverableBizEntity) { continue; } => this could not arise as handleDeliverableSubmission already does `if(this.deliverableBizEntity)`. Still for the sake of safety, moved it on top.
            if (data.config.link === RelationshipLinkType.Tight) {
              const entityParentId = await this.getEntityParentIdForTightlyLinkedEntity(data.config, this.deliverableBizEntity);
              let tightlyLinkedBizEntity = this.autoCreateEntitiesService.createBizEntityAutomaticallyFromBizEntity(this.deliverableBizEntity, data.name, data.additionalInfo, data.config, entityParentId);
              const tightlyLinkedCategory = tightlyLinkedBizEntity.type.category;
              (tightlyLinkedBizEntity as IDeliverable & { appId?: string; tenantId?: string }).appId = (tightlyLinkedBizEntity as IDeliverable).appId;
              (tightlyLinkedBizEntity as IDeliverable & { appId?: string; tenantId?: string }).tenantId = (tightlyLinkedBizEntity as IDeliverable).tenantId;
              const transformedTightlyLinked = benBizEntitySyncBeforeSendingToAPI(tightlyLinkedBizEntity as IBenBizEntity, this.userContextService);
              registeredRelationshipRecords.push({
                relationshipType: data.config.relationshipType,
                target: {
                  isNew: true,
                  bizEntity: transformedTightlyLinked,
                  category: tightlyLinkedCategory
                },
              });
            } else {
              // let bizEntity = this.benBizEntites.find(bizEntity => bizEntity.id.toString() === data.additionalInfo[0].value.toString());
              data.additionalInfo.forEach((addInfo: IAdditionalInfo & { selectedBizEntity?: IBizEntity }) => {
                if (addInfo.fieldMeta.type === FieldTypes.bizEntity && addInfo.value) {
                  let bizEntity = addInfo.selectedBizEntity || this.bizEntities.find(bizEntity => bizEntity.id.toString() === addInfo.value.toString());
                  if (bizEntity) {
                    registeredRelationshipRecords.push({
                      relationshipType: data.config.relationshipType,
                      target: {
                        isNew: false,
                        bizEntity: bizEntity.id,
                        category: bizEntity?.type.category
                      },
                    });
                  }
                }
              });
              // if(bizEntity){
              //   registeredRelationshipRecords.push({
              //     relationshipType: data.config.relationshipType,
              //     target:{
              //       isNew:false,
              //       bizEntity: bizEntity.id,
              //       category: bizEntity?.type.category
              //     },
              //   });
              // }
            }
          }
        }
        // This two line below are does not change the anything. Can it be removed?
        (this.deliverableBizEntity as IDeliverable & { appId?: string; tenantId?: string }).appId = (this.deliverableBizEntity as IDeliverable).appId;
        (this.deliverableBizEntity as IDeliverable & { appId?: string; tenantId?: string }).tenantId = (this.deliverableBizEntity as IDeliverable).tenantId;
        const transformedBizEntity = temporaryDeliverableSyncBeforeSendingToAPI(this.deliverableBizEntity as IDeliverable, this.userContextService);
        let relations: IBizEntityRelationships = {
          from: {
            isNew: true,
            bizEntity: transformedBizEntity,
            category: (this.deliverableBizEntity!).type.category
          },
          to: registeredRelationshipRecords,
        }
        this.relationshipStateStoreService.create(relations, false)?.then((data) => {
          notifyStrategyEntityCreated(this.deliverableBizEntity, data, () => {
            this.appStateService.incomingBizEntitySelectionId = data['bizEntityId'] ? String(data['bizEntityId']) : null;
          });
          this.submitPlan(data.bizEntityId);
          this.baseEntityFormComponent.afterSubmissionSucceeded();
          this.setAPICallInProgress(false);
        }).catch((error) => {
          this.toastService.toast(`Error creating relationships: ${error}`);
          this.setAPICallInProgress(false);
        });
      }
      else {
        this.setAPICallInProgress(false);
        // let registeredRelationshipRecords: IBizEntityRelationTarget[] = [];
        // this.relationshipAdditionalInfoForEdit.forEach((data: {config: IRelationshipConfiguration, bizEntity: IBizEntity}) => {
        //   registeredRelationshipRecords.push({
        //     relationshipType: data.config.relationshipType,
        //     target: {
        //       isNew: false,
        //       bizEntity: data.bizEntity?.id || '',
        //       category: data.bizEntity?.type?.category!
        //     },
        //   });
        // });
        // let relations: IBizEntityRelationships = {
        //   from:{
        //     isNew: false,
        //     bizEntity: this.bizEntity?.id || '',
        //     category: this.bizEntity?.type?.category!
        //   },
        //   to: registeredRelationshipRecords,
        // }
        // console.log("this.relationshipAdditionalInfoForEdit", relations);
        // // this.relationshipStateStoreService.update(relations, this.userService);
      }
      // }
    }
    else {
      this.toastService.toast('Please provide all the fields of the related entity Biz Entity.');
      this.setAPICallInProgress(false);
    }
  }
  // REFACTOR: This could maybe be done by the isValid property -@adithyasasi
  isRelationshipAdditionalInfoValid(): boolean {
    // Trigger all relationship field components to emit their data
    this.relationshipFieldsComponents.forEach(relationshipField => {
      relationshipField.getRelationshipFormFieldValues();
    });
    let isValid = true;
    this.relationshipAdditionalInfo.forEach((data: { config: IRelationshipConfiguration, name: string, additionalInfo: IAdditionalInfo[] }) => {
      data.additionalInfo.forEach((addInfo: IAdditionalInfo) => {
        if (addInfo.fieldMeta.isRequired && !addInfo.value) {
          isValid = false;
          return;
        }
      });
    });
    return isValid;
  }
  //Relationship config started
  doesHaveRelationship() {
    if (this.deliverableBizEntity?.type && this.deliverableBizEntity.type.relationshipConfiguration && this.deliverableBizEntity.type.relationshipConfiguration.length > 0) {
      return true;
    }
    return false;
  }
  doesBizEntityHaveTightlyLinkedBizEntity() {
    if (!this.doesHaveRelationship()) {
      return false;
    }
    if (this.deliverableBizEntity?.type && this.deliverableBizEntity.type.relationshipConfiguration && this.deliverableBizEntity.type.relationshipConfiguration.length > 0) {
      return this.deliverableBizEntity.type.relationshipConfiguration.some((config: IRelationshipConfiguration) => {
        if (config.cardinalityMin > 0) {
          if (config.link === RelationshipLinkType.Tight) {
            return true;
          }
        }
        return false;
      });
    }
    return false;
  }
  showRelationshipFields(config: IRelationshipConfiguration) {
    if (config.cardinalityMin > 0) {
      if (config.link === RelationshipLinkType.Tight) {
        return true;
      }
    }
    return true;
  }
  private extractTargetBizEntities(relationshipData: IBizEntityRelationships[]): IBizEntity[] {
    const targetBizEntities: IBizEntity[] = [];
    relationshipData.forEach((relationship: IBizEntityRelationships) => {
      if (relationship.to && Array.isArray(relationship.to)) {
        relationship.to.forEach((to: IBizEntityRelationTarget) => {
          if (to.target.bizEntity) {
            targetBizEntities.push(to.target.bizEntity as IBizEntity);
          }
        });
      }
    });
    return targetBizEntities;
  }

  private setAPICallInProgress(inProgress: boolean): void {
    this.isAPICallInProgress = inProgress;
    //TO Do : This diable/enable the submit button in the footer should be handled using key instead of index 0
    if (this.formFooterLayout && this.formFooterLayout.footer && this.formFooterLayout.footer.actions.length > 0) {
      this.formFooterLayout.footer.actions[0].isDisabled = inProgress;
    }
  }

  async getEntityParentIdForTightlyLinkedEntity(config: IRelationshipConfiguration, currentEntity: IBizEntity): Promise<string | undefined> {
    if (config?.targetType === RelationshipTargetType.BizEntityType) {
      const targetBizEntityTypeAppId = (config.target as IBizEntityType).appId;
      if (targetBizEntityTypeAppId && this.currentAppId !== targetBizEntityTypeAppId) {
        // const tenants = await this.tenantStateStoreService.fetch();
        // const tenant = tenants?.[0];
        // return tenant?.id;
        const xappCap = {
          appId: targetBizEntityTypeAppId,
        }

        const appRootEntity = await this.appRootStateStoreService.get(undefined, undefined, xappCap);
        return appRootEntity?.id?.toString();
      }
      return currentEntity.parentId?.toString();
    }
    return undefined;
  }
}
